import { I18nLanguage } from "_helpers/enum";
import { AuthUser } from "./authUser";

export class Comercial extends AuthUser {
    lastLogin: Date;
    devices: Date;
    loginToken: string;
    language: I18nLanguage;
}